var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RArray, RSet } from "../../collections";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { Volume } from "../Volume";
let ProductInstanceVolumeService = class ProductInstanceVolumeService {
    constructor() {
        makeImmutable(this);
    }
    volume(productInstance) {
        switch (productInstance.parts.type) {
            case "SinglePart":
                return this.singlePartVolume(productInstance.parts);
            case "Halves":
                return this.productInstanceHalvesVolume(productInstance.parts);
        }
    }
    singlePartVolume(parts) {
        const volume = this.productInstancePartVolume(parts.part);
        if (volume === null) {
            return null;
        }
        const { productTypeId } = parts.part;
        return {
            productTypeIds: RArray.singleton(productTypeId),
            packagedProductTypeIds: RSet.singleton(productTypeId),
            volume,
        };
    }
    productInstanceHalvesVolume(parts) {
        const packagedParts = new RArray([parts.first, parts.second]).mapOptional((part) => {
            const volume = this.productInstancePartVolume(part);
            return volume === null
                ? null
                : { productTypeId: part.productTypeId, volume };
        });
        if (packagedParts.isEmpty) {
            return null;
        }
        return {
            // NOTICE Both parts, including one without a packaging config of its own:
            // this is the key the backend demands packaging under.
            productTypeIds: RArray.unique(new RArray([parts.first.productTypeId, parts.second.productTypeId])),
            packagedProductTypeIds: RSet.fromIterable(packagedParts.map((part) => part.productTypeId), { ignoreDuplicates: true }),
            volume: packagedParts
                .map((part) => part.volume)
                .reduce((a, b) => a.max(b), Volume.empty()),
        };
    }
    productInstancePartVolume(productInstancePart) {
        return productInstancePart.productType.volume;
    }
};
ProductInstanceVolumeService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [])
], ProductInstanceVolumeService);
export { ProductInstanceVolumeService };
